import React from "react";
import { BorderBtn, Btn } from "../button.jsx/Btn";
import empImg from "../../assets/profile-placeholder.svg";
import { CandidatesTable, RecruitmentTable } from "../../components/Tables";

const CandidateTable = () => {
  const candidateData = [
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },

    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
    {
      image: empImg,
      name: "Cheryl E. Temilola",
      stagesPassed: "03/05",
      dateApplied: "17th March, 2025",
      emailaddress: "chere@gmail.com",
      department: "Product Design",
      action: "View Details",
    },
  ];

  return (
    <div className="w-full bg-white overflow-x-scroll rounded-lg border-b border-[#D3CBFB] mt-6 font-Nunito ">
      <div className="p-3">
        <div className=" flex mb-4 justify-between">
          <h1 className=" font-bold text-xl">All Candidates</h1>

          <div className=" flex gap-4">
            <BorderBtn>update</BorderBtn>
            <Btn>unpublish</Btn>
          </div>
        </div>
        <table className="w-full  text-black mb-6 border-collapse">
          <thead>
            <tr className="text-left">
              <th className="font-bold py-2 px-4">Name</th>
              <th className="font-bold py-2 px-4">Department</th>
              <th className="font-bold py-2 px-4">Email Address</th>
              <th className="font-bold py-2 px-4">Stages Passed</th>
              <th className="font-bold py-2 px-4">Date Applied</th>
              <th className="font-bold py-2 px-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {candidateData.map((candidate, index) => (
              <RecruitmentTable
                candidate={candidate}
                key={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CandidateTable;
